import { Navigate, useParams } from "react-router";
import ObjectDetailsPage from "../../../entityFields/ObjectDetailsPage";

const VendorDetailsPage = () => {
  const { id } = useParams();

  if (!id) {
    return <Navigate to=".." />;
  }

  return <ObjectDetailsPage objectId={id} objectType="Vendor" backButtonPath=".." />;
};

export default VendorDetailsPage;
